import { DocumentIcon } from '@heroicons/react/24/outline';
import { PageHeader } from '../components/PageHeader';
import ReconstructedDocumentsFilters from '../components/ReconstructedDocumentsFilters';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useReconstructedDocumentsList } from './reconstructedDocuments/useReconstructedDocumentsList';
import { ReconstructedDocumentsTableSection } from './reconstructedDocuments/ReconstructedDocumentsTableSection';

export default function ReconstructedDocuments() {
  useDocumentTitle('Reconstructed Documents');

  const { items, hasMore, loading, loadMore, totalCount, setFilters } = useReconstructedDocumentsList();

  return (
    <div>
      <PageHeader
        title="Reconstructed Documents"
        description={`${totalCount} entities`}
        icon={<DocumentIcon className="size-6" />}
      />

      <ReconstructedDocumentsFilters onFilterChange={setFilters} />

      <ReconstructedDocumentsTableSection
        items={items}
        loading={loading}
        hasMore={hasMore}
        onLoadMore={loadMore}
      />
    </div>
  );
}
